require('@babel/polyfill');
require('lazysizes');
require('./vendor/ls.blur-up.min.js');
require('./libs/magnificPopup.js');

import $ from 'jquery';

import './setup/axios';
import './setup/vue';
import './setup/search';
import './setup/flyout';

$('.tablinks').on('click', function() {
    let element = $(this).data('tab');
    $($('.tablinks.active')[0]).removeClass('active');
    $(this).addClass('active');
    $('.tabcontent').each(function() {
        if (this.id == 'id-' + element) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
});

window.copyLink = function(event) {
    var anchor = event.href;
    navigator.clipboard.writeText(anchor).then(
        () => {
            window.alert('Link is gekopieërd naar je clipboard');
        },
        () => {}
    );
};

if (window.location.hash) {
    // console.log(window.location.hash);
    let target = $('#' + window.location.hash.substr(1));
    $($('.tablinks.active')[0]).removeClass('active');
    $(target).click();
}

$('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate(
                    {
                        scrollTop: target.offset().top,
                    },
                    1000,
                    function() {
                        // Callback after animation
                        // Must change focus!
                        /*var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };*/
                    }
                );
            }
        }
    });

$('.js-search-trigger button, .js-search-close').on('click', function() {
    $('.js-search-block').toggleClass('is-active');
    $('.js-search-trigger').toggleClass('is-active');
    $('.js-search-input').focus();
});

var $document = $(document);
var $window = $(window);
var $form = $('.js-filter-form');
var $submit = $('.js-filter-submit').hide();
var $loader = $('.js-filter-loader').hide();
var $inputFilter = $('.js-filter-form input, .js-filter-form select');
var $result = $('.js-filter-results');
var $filters = $('.js-filters');
const $filterToggle = $('.js-filter-toggle');
const $showMore = $('.js-filter-show-more');
const $extraContent = $('.js-filter-extra-content');
var promise;
function initializeFilter() {
    $loader.hide();
    $form.on('change', $inputFilter, function(e) {
        $loader.fadeIn();
        $result.hide();
        var url = $form.attr('action') + '?' + $form.serialize();
        getFilter(url);
    });
    $result.on('click', '.js-filter-pagination a', function(e) {
        e.preventDefault();
        $loader.fadeIn();
        $result.hide();
        getFilter($(this).attr('href'));
    });
    $result.on('click', '.js-clear-filter-element', function(e) {
        e.preventDefault();
        $loader.fadeIn();
        $result.hide();
        const data = $(this).data('filter-elements');
        data.forEach(element => {
            $('[name="' + element.name + '"][value=' + element.value + ']').prop('checked', false);
        });

        var url = $form.attr('action') + '?' + $form.serialize();
        getFilter(url);
    });
    $showMore.on('click', function(e) {
        e.preventDefault();
        $(this).remove();
        $extraContent.removeClass('hidden');
    });
    $filterToggle.on('click', function(e) {
        e.preventDefault();
        $form.toggleClass('hidden');
    });
    // var indeterminate = $(".js-indeterminate");
    // indeterminate.hummingbird();
    // console.log(indeterminate);
}
function getFilter(url) {
    if (promise) {
        promise.abort();
    }
    promise = $.get(url);
    promise.then(
        function(filter) {
            $loader.hide();
            $result.html(
                $(filter)
                    .find('.js-filter-results')
                    .html()
            );
            $filters.html(
                $(filter)
                    .find('.js-filters')
                    .html()
            );
            $result.fadeIn();
            history.pushState('', 'New URL: ' + url, url);
        },
        function(error) {
            console.log(error);
        }
    );
}

initializeFilter();

if ($('.js-gallery').length > 0) {
    $('.js-gallery').magnificPopup({
        type: 'image',
        delegate: 'a',
        gallery: {
            enabled: true,
        },
    });
}
